import algoliasearch from 'algoliasearch/lite';
import { AisConfigure, AisHighlight, AisInstantSearch, AisSearchBox, AisStats } from 'vue-instantsearch';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './GlobalHeaderSearch.html';
import store from '../../store/store';

export default {
  template,

  mixins: [CdnMixin],

  components: {
    AisInstantSearch,
    AisSearchBox,
    AisHighlight,
    AisStats,
    AisConfigure,
  },

  props: {
    customerId: {
      type: Number,
      default: null,
    },
    siteId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      searchClient: algoliasearch('QPL7PXFK5U', '019627e6fe46f449cf99b13b2464dd74'),
      index: 'global',
      filters: this.getFilter(),
      selectedHitIndex: 0,
    };
  },

  computed: {
    // Proxy results from Algolia component
    hits() {
      if (!this.currentRefinement.length) {
        this.selectedHitIndex = 0;

        return [];
      }

      return this.$refs.aisAutocomplete.state.indices[0].hits;
    },

    currentRefinement() {
      return this.$refs.aisAutocomplete.state.currentRefinement;
    },
  },

  methods: {
    getFilter() {
      const andSiteId = `AND site_id:${this.siteId}`;

      if (typeof store.info.authUser !== 'undefined') {
        return `(belongs_to_customers:${store.info.authUser.customer.id} OR belongs_to_customers:"none") ${andSiteId}`;
      }

      if (this.customerId) {
        return `(belongs_to_customers:${this.customerId} OR belongs_to_customers:"none") ${andSiteId}`;
      }

      return `belongs_to_customers:"none" ${andSiteId}`;
    },

    goToSelectedHit() {
      if (typeof this.hits[this.selectedHitIndex] !== 'undefined') {
        window.location = this.hits[this.selectedHitIndex].url;
      }
    },

    up() {
      if (this.hits.length) {
        if (this.selectedHitIndex <= 0) {
          this.selectedHitIndex = this.hits.length - 1;
        } else if (this.selectedHitIndex > 0) {
          this.selectedHitIndex -= 1;
        }
      } else {
        this.selectedHitIndex = 0;
      }
    },

    down() {
      if (this.hits.length) {
        if (this.selectedHitIndex >= this.hits.length - 1) {
          this.selectedHitIndex = 0;
        } else {
          this.selectedHitIndex += 1;
        }
      } else {
        this.selectedHitIndex = 0;
      }
    },

    reset(refine) {
      this.selectedHitIndex = 0;
      refine('');
    },

    isSelectedHit(key) {
      return key === this.selectedHitIndex;
    },
  },
};
